import { render, staticRenderFns } from "./VideoLesson.vue?vue&type=template&id=246381fc&scoped=true&"
import script from "./VideoLesson.vue?vue&type=script&lang=js&"
export * from "./VideoLesson.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/pc/video_lesson.css?vue&type=style&index=0&id=246381fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246381fc",
  null
  
)

export default component.exports